module.exports = __webpack_public_path__ + "img/dy_p6_img_2.ab3c22b4.png";